import styled from 'styled-components';

import {
  Avatar,
  Card,
  Container,
  Input,
  Row,
  Text,
  Button,
} from '@gympass/yoga';
import { ArrowLeft } from '@gympass/yoga-icons';

export const UserInfoContainer = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Divisor = styled.hr`
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  margin: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const TabsContainer = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const TabMenu = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  li {
    cursor: pointer;
    width: auto;
    :hover {
      border-bottom-color: ${({ theme }) => theme.yoga.colors.primary};
      color: ${({ theme }) => theme.yoga.colors.primary};
    }
  }
  li[aria-selected='true'] {
    border-bottom-color: ${({ theme }) => theme.yoga.colors.primary};
    color: ${({ theme }) => theme.yoga.colors.primary};
  }
`;

export const BasicInfoContainer = styled(Card)`
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const EndUserAvatar = styled(Avatar.Circle)`
  width: ${({ theme }) => theme.yoga.sizes.avatarWidth}px;
  height: ${({ theme }) => theme.yoga.sizes.avatarHeight}px;
  background-color: ${({ theme }) => theme.yoga.colors.primaryLight};
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const EndUserAvatarText = styled(Text.H5)`
  color: ${({ theme }) => theme.yoga.colors.inputBackground};
`;

export const InputsContainer = styled(Container)`
  margin: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
  display: flex;
  flex-direction: row;
`;

export const ContainerRows = styled.div`
  width: 100%;
`;

export const RowsInfo = styled(Row)`
  width: 100%;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  margin: ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const InputInfo = styled(Input)`
  border-color: ${({ theme }) => theme.yoga.colors.inputDisabled} !important;
  color: ${({ theme }) => theme.yoga.colors.inputDisabled} !important;
`;

export const SessionsSection = styled(Card)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const SessionsContent = styled(Card.Content)`
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const StyledH5 = styled(Text.H5)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
`;

export const StyledArrowLeft = styled(ArrowLeft)`
  cursor: pointer;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const DischargeButton = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;
